import React, { useRef, useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import classNames from 'classnames'

import { Audio } from '../Audio/Audio'
import { Image } from '../Image/Image'
import { CustomDnd } from '../CustomDnd/CustomDnd'
import { getNextScreen, goNextScreen } from '../../store/screenSlice'
import bgImg from '../../resources/oldKzn.jpg'

import styles from './MapScreen.module.scss'
import mapImg from './map.png'
import mapPart01 from './01.png'
import mapPart02 from './02.png'
import mapPart03 from './03.png'
import mapPart04 from './04.png'
import mapPart05 from './05.png'
import mapPart0607 from './0607.png'
import mapPart08 from './08.png'
import winAudio from './win.mp3'


const PARTS = {
    '01': mapPart01,
    '02': mapPart02,
    '03': mapPart03,
    '04': mapPart04,
    '05': mapPart05,
    '0607': mapPart0607,
    '08': mapPart08,
}
const PART_KEYS = Object.keys(PARTS)

function MapScreenBody({ part, nextScreen, goNextScreen }) {
    const winAudioRef = useRef(null)

    const [win, setWin] = useState(false)

    const goalPartIndex = PART_KEYS.indexOf(part)

    const onDropped = useCallback(() => {
        setWin(true)
        winAudioRef.current.play()
    }, [setWin])

    const onAudioEnd = useCallback((audioEl) => {
        if (!nextScreen && (audioEl.currentTime + 2 > audioEl.duration)) {
            goNextScreen()
        }
    }, [nextScreen, goNextScreen])

    return (
        <CustomDnd onDropped={onDropped} className={styles.dndWrapper}>
            <Image src={bgImg} className={styles.bg} />
            <Image src={mapImg} className={styles.map} />

            {
                PART_KEYS
                    .filter((key, index) => index < goalPartIndex)
                    .map(key => (
                        <Image
                            key={key}
                            src={PARTS[key]}
                            className={classNames(`map-part-${key}`, styles.done)}
                        />
                    ))
            }

            <Image
                src={PARTS[part]}
                className={classNames(`map-part-${part}`, styles.dropZone)}
                droppable="map-part"
            />

            {
                win
                    ? (
                        <Image
                            src={PARTS[part]}
                            className={classNames(`map-part-${part}`, styles.done)}
                        />
                    )
                    : (
                        <Image
                            src={PARTS[part]}
                            className={`map-part-${part}`}
                            draggable="map-part"
                        />
                    )
            }

            <Audio audioRef={winAudioRef} src={winAudio} onTimeUpdate={onAudioEnd} />
        </CustomDnd>
    )
}

MapScreenBody.propTypes = {
    part: PropTypes.oneOf(['01', '02', '03', '04', '05', '0607', '08']),
    nextScreen: PropTypes.string,
    goNextScreen: PropTypes.func.isRequired,
}

const MapScreen = connect(
    state => ({
        nextScreen: getNextScreen(state),
    }), {
        goNextScreen,
    },
)(MapScreenBody)

MapScreen.propTypes = {
    part: PropTypes.oneOf(['01', '02', '03', '04', '05', '0607', '08']),
}

export { MapScreen }
